<div class="breadcrumb-bar" *ngIf="crumbs.length > 0" aria-label="Breadcrumb" role="navigation">
  <ol class="breadcrumb-list">
    <li class="crumb-item home">
      <a routerLink="/dashboard" class="crumb-link home-link" title="Home" aria-label="Home">
        <i class="pi pi-home"></i>
      </a>
    </li>

    <ng-container *ngFor="let crumb of crumbs; let last = last; let i = index">
      <li class="crumb-sep" aria-hidden="true"><i class="pi pi-chevron-right"></i></li>
      <li class="crumb-item" [class.active]="last">
        <span *ngIf="last" class="crumb-current" aria-current="page">{{ crumb }}</span>
        <a *ngIf="!last" class="crumb-link" [routerLink]="getCrumbLink(i)">{{ crumb }}</a>
      </li>
    </ng-container>
  </ol>
</div>
